module.exports = __webpack_public_path__ + "public/files/img/error-dark.145f4548.svg";